import { NAVIGATION_BADGE_NO_BADGE } from './constants';

const navigationTrackings = {
  home: {
    sc_o: 'navigation_my_startpage',
    sc_o_PropActionOrigin: NAVIGATION_BADGE_NO_BADGE,
  },
  contacts: {
    sc_o: 'navigation_contacts',
    sc_o_PropActionOrigin: [
      'navigation_badge_contacts',
      NAVIGATION_BADGE_NO_BADGE,
    ],
  },
  messages: {
    sc_o: 'navigation_messages',
    sc_o_PropActionOrigin: [
      'navigation_badge_messages',
      NAVIGATION_BADGE_NO_BADGE,
    ],
  },
  premiumUpsell: {
    sc_o: 'navigation_premium',
    sc_o_PropActionOrigin: NAVIGATION_BADGE_NO_BADGE,
  },
  premium: {
    sc_o: 'mxb_pre',
    sc_o_PropActionOrigin: NAVIGATION_BADGE_NO_BADGE,
  },
  proJobs: {
    sc_o: 'ojm-467_navigation',
  },
  proBusiness: {
    sc_o: 'navigation_probusiness',
  },
  jobs: {
    sc_o: 'navigation_jobs',
    sc_o_PropActionOrigin: ['navigation_badge_jobs', NAVIGATION_BADGE_NO_BADGE],
  },
  events: {
    sc_o: 'navigation_events',
    sc_o_PropActionOrigin: [
      'navigation_badge_events',
      NAVIGATION_BADGE_NO_BADGE,
    ],
  },
  content: {
    sc_o: 'navigation_news',
    sc_o_PropActionOrigin: ['navigation_badge_news', NAVIGATION_BADGE_NO_BADGE],
  },
  groups: {
    sc_o: 'navigation_groups',
    sc_o_PropActionOrigin: [
      'navigation_badge_groups',
      NAVIGATION_BADGE_NO_BADGE,
    ],
  },
  companies: {
    sc_o: 'navigation_companies',
    sc_o_PropActionOrigin: NAVIGATION_BADGE_NO_BADGE,
  },
  business: {
    sc_o: 'navigation_business_solutions',
    sc_o_PropActionOrigin: NAVIGATION_BADGE_NO_BADGE,
  },
  services: {
    sc_o: 'navigation_other_services',
    sc_o_PropActionOrigin: NAVIGATION_BADGE_NO_BADGE,
  },
  profile: {
    sc_o: 'navigation_header',
    sc_o_PropActionOrigin: [
      'navigation_badge_header',
      NAVIGATION_BADGE_NO_BADGE,
    ],
  },
  language: {
    sc_o: 'navigation_footer',
    sc_o_PropActionOrigin: [
      'navigation_badge_footer',
      NAVIGATION_BADGE_NO_BADGE,
    ],
  },
  settingsPersonal: {
    sc_o: 'navigation_settings',
    sc_o_PropActionOrigin: NAVIGATION_BADGE_NO_BADGE,
  },
};

export { navigationTrackings };
